import React, {Fragment} from "react";
import {Col, Input, Row} from "reactstrap";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import {
    ADDRESS_DETAILS_CONFIG,
    BUTTON_HEADERS,
    CONTACT_DETAILS_CONFIG,
    DOCUMENT_DETAILS_CONFIG,
    GENDER,
    ID_TYPES,
    IDENTITY_DETAILS_CONFIG,
    PERSONAL_DETAILS_CONFIG,
    TITLES
} from "./AgentFormConfig";
import DropdownComponent from "../../components/DropdownComponent";
import DatePickerComponent from "../../components/DatePickerComponent";
import UtilityService from "../../services/UtilityService";
import {withRouter} from "react-router-dom";
import S3DocumentUploadComponent from "../../components/S3DocumentUploadComponent";
import AdminAgentDocumentTypeService from "../../services/adminagentdocumentype/AdminAgentDocumentTypeService";
import AgentCreateResponse from "./AgentCreateResponse";
import FileUtil from "../../domain/Util/FileUtil";
import ToastHelper from "../../utils/ToastHelper";
import ManagedAgentService from "../../services/managedagentonboarding/ManagedAgentService";
import UserSessionService from "../../services/UserSessionService";
import S3DocumentUploadService from "../../services/S3DocumentUploadService";


const SA_ID = "SA ID";
const PERSONAL_DETAILS = "personal details";
const IDENTITY_DETAILS = "identity details";
const ADDRESS_DETAILS = "address details";
const CONTACT_DETAILS = "contact details";
const FIRST_DOCUMENT_DETAILS = "first document details";
const SECOND_DOCUMENT_DETAILS = " second document details";
const AGENT_CREATE_SUMMARY_PAGE = "summary details";


const NEXT_BUTTON_TEXT = "Next";
const BACK_BUTTON_TEXT = "Back";

class AgentCreate extends React.Component {
    constructor(props) {
        super(props);

        this.managerId = UserSessionService.getUser().user.id;
        this.organisationId = UserSessionService.getUser().user.organisationId;
        this.registeringPartnerId = UserSessionService.getUser().registeringPartnerId;
        this.registeringChannelId = UserSessionService.getUser().registeringChannelId;

        this.state = {
            viewMode: this.props.viewMode,
            firstName: "",
            lastName: "",
            title: {"id": 0, "name": ""},
            gender: {"id": 0, "name": ""},
            dateOfBirth: "",

            externalAgentIdentifier: "",

            idType: {"id": 0, "name": ""},
            idNumber: "",
            idExpiryDate: '',
            country: {"id": "", "name": ""},
            idIssuingCountry: {"id": "", "name": ""},
            nationality: {"id": "", "name": ""},

            streetNumber: "",
            streetName: "",
            suburb: "",
            city: "",
            province: {"id": 0, "name": ""},
            postalCode: "",

            phoneNumber: "",
            alternativePhoneNumber: "",
            email: "",

            touchedFields: {},
            inValidFields: {},
            validFields: {},

            requiredDocuments: [],
            selectedDocuments: {},
            uploadedDocuments: {},

            currentTab: PERSONAL_DETAILS,

            selectedOption: {}
        }


        this.schema = AgentCreateResponse.retrieveNewAgentValidationConfig();

        this.showNextDetailsPage = this.showNextDetailsPage.bind(this);
        this.goBack = this.goBack.bind(this);
        this.renderNextButton = this.renderNextButton.bind(this);
        this.renderBackButton = this.renderBackButton.bind(this);
        this.renderInput = this.renderInput.bind(this);
        this.renderDropdown = this.renderDropdown.bind(this);

    }

    componentDidMount() {

        let promiseArr = [];

        promiseArr.push(UtilityService.retrieveCountryList());
        promiseArr.push(UtilityService.retrieveProvinceList());
        promiseArr.push(AdminAgentDocumentTypeService.retrieveDocumentTypes());

        Promise.all(promiseArr).then(response => {

            let countryList = response[0];
            let provinceList = response[1];
            let requiredDocumentsList = response[2];

            this.setState({
                countryOptions: countryList,
                provinceOptions: provinceList,
                requiredDocuments: requiredDocumentsList,
                loading: false
            })
        })
    }

    showNextDetailsPage(nextPage) {
        this.setState({
            currentTab: nextPage
        })
    }

    goBack() {

        if (this.state.currentTab === PERSONAL_DETAILS) {
            this.props.history.replace("/agents");
            this.props.btnBackClick()
        } else if (this.state.currentTab === IDENTITY_DETAILS) {
            this.setState({
                currentTab: PERSONAL_DETAILS
            })
        } else if (this.state.currentTab === ADDRESS_DETAILS) {
            this.setState({
                currentTab: IDENTITY_DETAILS
            })
        } else if (this.state.currentTab === CONTACT_DETAILS) {
            this.setState({
                currentTab: ADDRESS_DETAILS
            })
        } else if (this.state.currentTab === FIRST_DOCUMENT_DETAILS) {
            this.setState({
                currentTab: CONTACT_DETAILS
            })
        } else if (this.state.currentTab === SECOND_DOCUMENT_DETAILS) {
            this.setState({
                currentTab: FIRST_DOCUMENT_DETAILS
            })
        } else if (this.state.currentTab === AGENT_CREATE_SUMMARY_PAGE) {
            this.props.history.replace("/agents");
            this.props.btnBackClick()
        }
    }

    invalidateIdNumber() {
        let previousValidState = {...this.state.validFields};
        delete previousValidState["idNumber"];
        this.setState({
            idNumber: "",
            validFields: previousValidState
        });
    }

    hasBeenTouched(field) {

        let previousTouched = {...this.state.touchedFields};
        previousTouched[field] = true;
        this.setState({
                touchedFields: previousTouched
            }, () => this.validateInputField(field)
        )
    }

    validateInputField(field) {
        let self = this;
        let previousInvalidValidations = {...this.state.inValidFields};
        delete previousInvalidValidations[field];
        let previousValidValidations = {...this.state.validFields};
        previousValidValidations[field] = true;

        this.setState({
            inValidFields: previousInvalidValidations,
            validFields: previousValidValidations
        }, () => {
            let fieldValue = this.state[field].id === undefined ? this.state[field] : this.state[field].name;

            if (field === "idType" && fieldValue === SA_ID) {
                delete this.schema["idNumber"];
                this.schema["idNumber"] = AgentCreateResponse.retrieveSAIDValidationConfig()
                this.invalidateIdNumber();
            } else if (field === "idType" && fieldValue !== SA_ID) {
                delete this.schema["idNumber"];
                this.schema["idNumber"] = AgentCreateResponse.retrieveNonSAIDValidationConfig();
                this.invalidateIdNumber();
            }

            if (this.schema[field] !== undefined) {
                this.schema[field].validate({[field]: fieldValue}).catch(function (err) {

                    let previousInvalidValidations = {...self.state.inValidFields};
                    previousInvalidValidations[field] = err.message;
                    let previousValidValidations = {...self.state.validFields};
                    delete previousValidValidations[field];
                    self.setState({
                        inValidFields: previousInvalidValidations,
                        validFields: previousValidValidations
                    });
                })
            }
        })
    }

    handleUpload() {
        let selectedLength = Object.keys(this.state.selectedDocuments).length
        if (selectedLength === 0) {
            this.createManagedAgent()
        } else {
            let self = this;
            Object.keys(this.state.selectedDocuments).forEach(selectedDocument => {
                let documentType = selectedDocument;

                let file = this.state.selectedDocuments[selectedDocument];

                let fileType = FileUtil.getExtensionOfFile(file.fileUpload.name);
                let mimeType = FileUtil.getMimeType(fileType);

                let s3Document = {
                    "file-type": fileType,
                    "document-type": "AGENT_DOCUMENT"
                };

                S3DocumentUploadService.getPresignedUrl(s3Document).then(response => {
                    if (response.presignedUrl === undefined) {
                        ToastHelper.error("Failed to retrieve upload url.");
                        return;
                    }

                    const xhr = new XMLHttpRequest();
                    xhr.open('PUT', response.presignedUrl);
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState === 4) {
                            if (xhr.status === 200) {
                                let uploadedDocument = {...self.state.uploadedDocuments};
                                uploadedDocument[documentType] = response;
                                self.setState({
                                    uploadedDocuments: uploadedDocument
                                }, () => self.doneUploadingDocuments());

                            } else {
                                ToastHelper.error("Error while uploading image.");
                            }
                        }
                    };
                    xhr.overrideMimeType(mimeType);
                    xhr.setRequestHeader('Content-Type', mimeType);
                    xhr.send(file.fileUpload);
                });
            });


        }
    }

    doneUploadingDocuments() {

        let uploadedLength = Object.keys(this.state.uploadedDocuments).length
        let selectedLength = Object.keys(this.state.selectedDocuments).length
        if (uploadedLength === selectedLength) {
            let allUploaded = {};
            Object.keys(this.state.selectedDocuments).forEach(selectedDocument => {
                if (this.state.uploadedDocuments[selectedDocument].documentType === undefined) {
                    allUploaded[selectedDocument] = false;
                    ToastHelper.error("Error while uploading image.");
                } else {
                    allUploaded[selectedDocument] = true;
                }
            });


            function getKeyByValue(object, value) {
                return Object.keys(object).find(key =>
                    object[key] === value);
            }

            if (getKeyByValue(allUploaded, false) === undefined) {
                this.createManagedAgent()
            } else {
                this.setState({
                    loading: false
                })
            }
        } else {
        }
    }

    doneSelectingDocument(documentType) {
        let allSelected = true;
        if (this.state.selectedDocuments[documentType] === undefined) {
            allSelected = false;
            ToastHelper.warning("Please ensure that we can see all four corners of the document you upload!", 7000)
        }

        return allSelected;
    }


    createManagedAgent() {

        if (this.submitting) {
            return;
        }

        this.submitting = true;

        let documents = [];

        let uploadedDocumentsKeysArray = Object.keys(this.state.uploadedDocuments)
        for (let i = 0; i < uploadedDocumentsKeysArray.length; i++) {
            if (uploadedDocumentsKeysArray[i] === "Identity") {
                documents.push({
                    "metaDataId": this.state.uploadedDocuments["Identity"].id,
                    "agentDocumentType": this.state.requiredDocuments[i].name
                })
            }
            if (uploadedDocumentsKeysArray[i] === "Picture") {
                documents.push({
                    "metaDataId": this.state.uploadedDocuments["Picture"].id,
                    "agentDocumentType": this.state.requiredDocuments[i].name
                })
            }
        }

        let contacts = []


        if (this.state.alternativePhoneNumber !== "") {
            contacts.push(
                {
                    contactValue: this.state.alternativePhoneNumber,
                    primary: false,
                    contactType: "MSISDN",
                    contactName: this.state.firstName
                }
            )
        }
        if (this.state.email !== "") {
            contacts.push(
                {
                    contactValue: this.state.email,
                    primary: false,
                    contactType: "EMAIL",
                    contactName: this.state.firstName
                }
            )
        }
        if (this.state.phoneNumber !== "") {
            contacts.push(
                {
                    contactValue: this.state.phoneNumber,
                    primary: true,
                    contactType: "MSISDN",
                    contactName: this.state.firstName
                }
            )
        }

        const agentCreationRequest = {
            organisationId: this.organisationId,
            manager: false,
            agentType: "PERSON",
            person: {
                title:this.state.title.id,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                gender: this.state.gender.id,
                dateOfBirth: this.state.dateOfBirth,
            },
            address: {
                streetNumber: this.state.streetNumber,
                streetName: this.state.streetName,
                suburb: this.state.suburb,
                city: this.state.city,
                province: this.state.province.name,
                postalCode: this.state.postalCode
            },
            documents: documents,
            identity: {
                idType: this.state.idType.name,
                idNumber: this.state.idNumber,
                idIssuingCountry: this.state.idIssuingCountry.id,
                nationality: this.state.nationality.id,
                originCountry: this.state.nationality.id,

            },
            contacts: contacts

        }


        if (this.state.externalAgentIdentifier !== "") {
            agentCreationRequest["externalAgentIdentifier"] = this.state.externalAgentIdentifier
        }

        if (agentCreationRequest["identity"].idType === SA_ID) {
            agentCreationRequest["identity"].idExpiryDate = "9999-12-31";

        } else {
            agentCreationRequest["identity"].idExpiryDate = this.state.idExpiryDate;
        }

        ManagedAgentService.createManagedAgent(agentCreationRequest, this.managerId, this.registeringPartnerId, this.registeringChannelId).then(response => {
            if (response.id) {
                ToastHelper.success("Created agent successfully!")
                this.setState({
                    currentTab: AGENT_CREATE_SUMMARY_PAGE,
                    loading: false
                });
            } else {
                this.submitting = false;
                this.setState({
                    loading: false,
                    submitButtonClicked: false
                });
                ToastHelper.formatError(response)
            }
        })

    }

    isNextButtonValid(config) {

        let allFieldsComplete = true;

        config.forEach(field => {
            if ((field === "externalAgentIdentifier")
                || (field === "alternativePhoneNumber")
                || (field === "email")) {

            } else if (this.state.validFields[field] === undefined) {
                allFieldsComplete = false;
            }
        });

        if (this.state.currentTab === FIRST_DOCUMENT_DETAILS) {
            allFieldsComplete = this.doneSelectingDocument("Identity") && allFieldsComplete;

        }
        if (this.state.currentTab === SECOND_DOCUMENT_DETAILS) {
            allFieldsComplete = this.doneSelectingDocument("Picture") && allFieldsComplete;
        }


        return allFieldsComplete;
    }

    renderNextButton(buttonText, detailsPage, className, config) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_register_button"}
                onClick={() => this.showNextDetailsPage(detailsPage)}
                disabled={!this.isNextButtonValid(config)}
            >{buttonText}
            </SFXButtonComponent>
        </div>
    }

    handleChange = (event, field) => {

        this.setState({
            [event.target.id]: event.target.value
        }, () => {
            this.validateInputField(field)
        });
    };

    handleDateChange(field, value) {

        this.setState({
            [field]: value
        }, () => this.validateInputField(field))
    }

    dropdownChange = (event, field) => {

        let newEvent;
        if (event === null) {
            if (field === "idIssuingCountry" || field === "nationality") {
                newEvent = {"id": "", "name": ""}
            } else {
                newEvent = {"id": 0, "name": ""}
            }
        } else {
            newEvent = {...event};
        }
        this.setState({
            [field]: {
                id: newEvent.id,
                name: newEvent.name
            },
        }, () => this.validateInputField(field));
    };

    renderBackButton(buttonText, className) {

        return <Fragment>
            <div className={className + "_register_button_div"}>
                <SFXButtonComponent
                    className={"browser_register_back_button"}
                    onClick={() => this.goBack()}
                >{buttonText}
                </SFXButtonComponent>
            </div>
        </Fragment>
    }

    renderInput(className, text, field, icon, additionalInfo) {
        return <Row className={className + "_input_row_register"}>
            <div className={"fa fa-" + icon + " " + className + "_user_icon_register"}/>
            <div className={className + "_input_div_register"}>
                <Input className={className + "_input_register"} value={this.state[field]} placeholder={text}
                       id={field}
                       onChange={(event) => this.handleChange(event, field)}
                       onBlur={() => this.hasBeenTouched(field)}
                />
                {this.state.touchedFields[field] && this.state.inValidFields[field] && this.renderErrorMessage(className, field)}
                {additionalInfo && this.renderAdditionalInfo(className, additionalInfo)}
            </div>
        </Row>
    }

    renderDropdown(className, dropdownOptions, field, text, icon) {

        return <Row className={className + "_input_row_register"}>
            <div className={"fa fa-" + icon + " " + className + "_user_icon_register"}/>
            <div className={className + "_input_div_register"}>
                <DropdownComponent
                    className={className + "_input_register"}
                    value={this.state[field].id || "" || 0}
                    options={dropdownOptions}
                    placeholder={text}
                    onChange={(selectedOption) => {
                        this.dropdownChange(selectedOption, field)
                    }}
                    onBlur={() => this.hasBeenTouched(field)}
                />
                {this.state.touchedFields[field] && this.state.inValidFields[field] && this.renderErrorMessage(className, field)}
            </div>
        </Row>
    }


    renderDatePicker(className, text, field) {

        let dateType = "";
        if (field === "dateOfBirth") {
            dateType = "PAST";
        } else if (field === "idExpiryDate") {
            dateType = "ID_EXPIRY";
        } else if (field === "idIssueDate") {
            dateType = "PAST";
        }

        return <Row className={className + "_input_row_register"}>
            <div className={"fa fa-calendar " + className + "_user_icon_register"}/>
            <div className={className + "_input_div_register"}>
                <DatePickerComponent
                    inputStyle={className + "_input_register"}
                    onChange={(value) => {
                        this.handleDateChange(field, value)
                    }}
                    isMobile={this.props.isMobile}
                    firstTouch={() => this.hasBeenTouched(field)}
                    value={this.state[field]}
                    placeholder={text}
                    type={dateType}
                />
                {this.state.touchedFields[field] && this.state.inValidFields[field] && this.renderErrorMessage(className, field)}
            </div>
        </Row>

    }

    renderErrorMessage(className, field) {
        return <h6 className={className + "_error_message_register"}>
            {this.state.inValidFields[field]}
        </h6>;
    }

    renderAdditionalInfo(className, text) {
        return <h6 className={className + "_optional_message_register"}>
            {text}
        </h6>;
    }

    renderSubmitButton(buttonText, className, config) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_register_button"}
                onClick={() => this.setState({
                    submitButtonClicked: true,
                    loading: true,
                    loadingMessage: "Creating Agent"
                }, this.handleUpload)}
                disabled={!this.isNextButtonValid(config)}
            >{buttonText}
            </SFXButtonComponent>
        </div>

    }

    render() {
        return (
            <Fragment>
                {this.props.isMobile ? this.renderContent("mobile") : this.renderContent("browser")}
            </Fragment>
        )
    }

    renderContent(className) {

        return <Fragment>

            <div className={className + "_background_default_register"}>
                <div className={className + " logo_register"}>
                    <Col align={"center"}>
                        {this.props.isMobile ?
                            <img src={"/images/ria-logo.png"} alt=""
                                 width="auto" height="50px"/> :
                            <div style={{marginTop: "10px"}}>
                                <h1 className={"browser_register_main_heading"}>Sign Up New Agent</h1>
                            </div>
                        }
                        <br/>
                        <br/>
                    </Col>
                </div>

                <div className={className + "_register_detail_fields"}>
                    <br/>
                    <br/>
                    {this.state.currentTab === PERSONAL_DETAILS && this.renderPersonalDetails(className)}
                    {this.state.currentTab === IDENTITY_DETAILS && this.renderIdentityDetails(className)}
                    {this.state.currentTab === ADDRESS_DETAILS && this.renderAddressDetails(className)}
                    {this.state.currentTab === CONTACT_DETAILS && this.renderContactDetails(className)}
                    {this.state.currentTab === FIRST_DOCUMENT_DETAILS && this.renderFirstDocument(className)}
                    {this.state.currentTab === SECOND_DOCUMENT_DETAILS && this.renderSecondDocuments(className)}
                    {this.state.currentTab === AGENT_CREATE_SUMMARY_PAGE && this.renderSummary(className)}
                </div>
            </div>

        </Fragment>
    }

    renderPersonalDetails(className) {
        let additionalInfo = "(Optional)"
        return <Fragment>
            {!this.props.isMobile ? <Fragment><h2 className={"browser_register_sub_heading"}>Personal Details</h2>
                    <br/>
                </Fragment>
                :
                <Fragment>

                </Fragment>
            }

            {this.renderDropdown(className, TITLES, "title", "Title", "user")}
            {this.renderInput(className, "First Name", "firstName", "user")}
            {this.renderInput(className, "Last Name", "lastName", "user")}
            {this.renderDropdown(className, GENDER, "gender", "Gender", "user")}
            {this.renderInput(className, "External Agent Identifier", "externalAgentIdentifier", "user", additionalInfo)}
            {this.renderDatePicker(className, "Date of Birth", "dateOfBirth")}

            {this.renderNextButton(NEXT_BUTTON_TEXT, IDENTITY_DETAILS, className, PERSONAL_DETAILS_CONFIG)}
            {this.renderBackButton(BACK_BUTTON_TEXT, className)}
        </Fragment>

    }


    renderIdentityDetails(className) {
        return <Fragment>
            {!this.props.isMobile ? <Fragment><h2 className={"browser_register_sub_heading"}>Identity Details</h2>
                    <br/>
                </Fragment>
                :
                <Fragment>

                </Fragment>
            }

            {this.renderDropdown(className, ID_TYPES, "idType", "ID Type", "flag")}
            {this.renderInput(className, "ID Number", "idNumber", "flag")}
            {this.state.idType.name !== "SA ID" ? this.renderDatePicker(className, "ID Expiry Date", "idExpiryDate") : ""}
            {this.renderDropdown(className, this.state.countryOptions, "idIssuingCountry", "ID Issuing Country", "flag")}
            {this.renderDropdown(className, this.state.countryOptions, "nationality", "Nationality", "flag")}

            {this.renderNextButton(NEXT_BUTTON_TEXT, ADDRESS_DETAILS, className, IDENTITY_DETAILS_CONFIG)}
            {this.renderBackButton(BACK_BUTTON_TEXT, className)}
        </Fragment>

    }

    renderAddressDetails(className) {

        return <Fragment>
            {!this.props.isMobile ? <Fragment><h2 className={"browser_register_sub_heading"}>Address Details</h2>
                    <br/>
                </Fragment>
                :
                <Fragment>

                </Fragment>
            }
            {this.renderInput(className, "Street Number", "streetNumber", "map-marker")}
            {this.renderInput(className, "Street Name", "streetName", "map-marker")}
            {this.renderInput(className, "Suburb", "suburb", "map-marker")}
            {this.renderInput(className, "City", "city", "map-marker")}
            {this.renderDropdown(className, this.state.provinceOptions, "province", "Province", "map-marker")}
            {this.renderInput(className, "Postal Code", "postalCode", "map-marker")}

            {this.renderNextButton(NEXT_BUTTON_TEXT, CONTACT_DETAILS, className, ADDRESS_DETAILS_CONFIG)}
            {this.renderBackButton(BACK_BUTTON_TEXT, className)}
        </Fragment>
    }

    renderContactDetails(className) {
        let additionalInfo = "(Optional)"
        return <Fragment>
            {!this.props.isMobile ? <Fragment><h2 className={"browser_register_sub_heading"}>Contact Details</h2>
                    <br/>
                </Fragment>
                :
                <Fragment>

                </Fragment>
            }

            {this.renderInput(className, "Primary Phone Number", "phoneNumber", "phone", "(This number should be able to receive SMSs)")}
            {this.renderInput(className, "Alternative Phone Number", "alternativePhoneNumber", "phone", additionalInfo)}
            {this.renderInput(className, "Email Address", "email", "envelope", additionalInfo)}

            {this.renderNextButton(NEXT_BUTTON_TEXT, FIRST_DOCUMENT_DETAILS, className, CONTACT_DETAILS_CONFIG)}
            {this.renderBackButton(BACK_BUTTON_TEXT, className)}

        </Fragment>

    }


    renderFirstDocument(className) {
        return <Fragment>
            {!this.props.isMobile ? <Fragment><h2 className={"browser_register_sub_heading"}>Documents</h2>
                    <br/>
                </Fragment>
                :
                <Fragment>

                </Fragment>
            }

            <S3DocumentUploadComponent
                key={0}
                documentType={this.state.requiredDocuments[1].displayValue}
                showButton={false}
                buttonConfig={BUTTON_HEADERS[this.state.requiredDocuments[1].displayValue]}
                className={className}
                fileSelected={this.state.selectedDocuments[this.state.requiredDocuments[1].displayValue] !== undefined}
                onFileSelected={file => {
                    if (file !== null) {
                        let docArr = {...this.state.selectedDocuments};
                        docArr[this.state.requiredDocuments[1].displayValue] = file;
                        this.setState({
                            selectedDocuments: docArr
                        })
                    }
                }}

            />
            {this.renderNextButton(NEXT_BUTTON_TEXT, SECOND_DOCUMENT_DETAILS, className, DOCUMENT_DETAILS_CONFIG)}
            {this.renderBackButton(BACK_BUTTON_TEXT, className)}
        </Fragment>
    }


    renderSecondDocuments(className) {
        return <Fragment>
            {!this.props.isMobile ? <Fragment><h2 className={"browser_register_sub_heading"}>Documents</h2>
                    <br/>
                </Fragment>
                :
                <Fragment>

                </Fragment>
            }
            <S3DocumentUploadComponent
                key={0}
                documentType={this.state.requiredDocuments[0].displayValue}
                showButton={false}
                buttonConfig={BUTTON_HEADERS[this.state.requiredDocuments[0].displayValue]}
                className={className}
                fileSelected={this.state.selectedDocuments[this.state.requiredDocuments[0].displayValue] !== undefined}
                onFileSelected={file => {
                    if (file !== null) {
                        let docArr = {...this.state.selectedDocuments};
                        docArr[this.state.requiredDocuments[0].displayValue] = file;
                        this.setState({
                            selectedDocuments: docArr
                        })
                    }
                }}

            />
            {this.renderSubmitButton("Submit", className, DOCUMENT_DETAILS_CONFIG)}
            {this.renderBackButton(BACK_BUTTON_TEXT, className)}
        </Fragment>
    }

    renderSummary(className) {

        return <Fragment>

            {!this.props.isMobile ?
                <Fragment><h2 className={"browser_register_sub_heading"}>Agent Creation Complete</h2>
                    <br/>
                </Fragment>
                :
                <Fragment>

                </Fragment>
            }

            <h2 className={className + "_register_sub_heading text-center"}>Thank you!</h2>
            <p className={"text-center"}>This agent creation is under review - the agent will be notified once it has
                been approved</p>
            <br/>
            {this.renderBackButton("Done", className)}

        </Fragment>
    }
}

export default withRouter(AgentCreate)